import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "c-upload" }
const _hoisted_2 = { class: "add-btn-box" }
const _hoisted_3 = { class: "upload-label label-ti" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "附件", -1)
const _hoisted_5 = {
  key: 0,
  class: "c-label-must"
}
const _hoisted_6 = { class: "add-btn" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "icon-add" }, null, -1)
const _hoisted_8 = { class: "upload-top" }
const _hoisted_9 = { class: "upload-tip" }
const _hoisted_10 = { class: "upload-num" }
const _hoisted_11 = { class: "file-list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "file-info" }
const _hoisted_16 = { class: "file-name" }
const _hoisted_17 = { class: "file-size" }
const _hoisted_18 = {
  key: 2,
  class: "file-error"
}
const _hoisted_19 = { class: "file-state" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.must)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("input", {
          type: "file",
          class: "select-file",
          multiple: "",
          accept: "*",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectFile && _ctx.selectFile(...args)))
        }, null, 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, "文件大小不能超过" + _toDisplayString(_ctx.limitText), 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.list.length) + "/" + _toDisplayString(_ctx.limit), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (file, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "file-item",
          onClick: ($event: any) => (_ctx.operate(i))
        }, [
          (file.url && file.type == 'image')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: file.url,
                mode: "aspectFill",
                class: "file-img"
              }, null, 8, _hoisted_13))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: `${_ctx.prefix}${file.type}.png`,
                mode: "aspectFill",
                class: "file-img"
              }, null, 8, _hoisted_14)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("text", null, _toDisplayString(file.fileName), 1)
            ]),
            _createElementVNode("div", _hoisted_17, _toDisplayString(file.sizeText), 1)
          ]),
          (file.state == 'error')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, "上传失败"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_c_icon, {
              class: _normalizeClass(["state-icon", [`state-icon-${file.state}`]]),
              name: _ctx.stateIcon[file.state]
            }, null, 8, ["class", "name"])
          ])
        ], 8, _hoisted_12))
      }), 128))
    ])
  ]))
}